import { render, staticRenderFns } from "./PreliminaryResultsTemplate.vue?vue&type=template&id=5c73af14&scoped=true"
import script from "./PreliminaryResultsTemplate.vue?vue&type=script&lang=js"
export * from "./PreliminaryResultsTemplate.vue?vue&type=script&lang=js"
import style0 from "./PreliminaryResultsTemplate.vue?vue&type=style&index=0&id=5c73af14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c73af14",
  null
  
)

export default component.exports